import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Button } from '@/components/ui/button';

/** Một màn hình lỗi không làm sập cả ứng dụng; dữ liệu không bị ảnh hưởng. */
export default class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null };
  static getDerivedStateFromError(error: Error) { return { error }; }
  componentDidCatch(error: Error, info: ErrorInfo) { console.error('v2 UI error:', error, info.componentStack); }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div role="alert" className="mx-auto max-w-md space-y-3 p-8 text-center">
        <h2 className="text-lg font-semibold">Phần này gặp lỗi hiển thị</h2>
        <p className="text-sm text-muted-foreground">Dữ liệu của bạn vẫn an toàn — chỉ phần giao diện này bị lỗi. Thử tải lại; nếu lỗi lặp lại, chuyển sang mục khác.</p>
        <div className="flex justify-center gap-2">
          <Button onClick={() => this.setState({ error: null })}>Thử lại</Button>
          <Button variant="outline" onClick={() => window.location.reload()}>Tải lại trang</Button>
        </div>
      </div>
    );
  }
}
